export const state = () => ({
  loading: false,
  /* User */
  userName: 'John Doe',
  userEmail: null,
  userAvatar: null,
  /* NavBar */
  isNavBarVisible: true,

  /* Aside */
  isAsideMobileExpanded: false,

  /* NavBarHomePage */
  isActiveNavBarHomePage: false,

  isOpenMenuMobile: false,

  myProjects: [],
})

export const mutations = {
  /* A fit-them-all commit */
  basic(state, payload) {
    state[payload.key] = payload.value
  },

  /* User */
  user(state, payload) {
    if (payload.name) {
      state.userName = payload.name
    }
    if (payload.email) {
      state.userEmail = payload.email
    }
    if (payload.avatar) {
      state.userAvatar = payload.avatar
    }
  },

  loading(state, loading) {
    state.loading = loading
  },

  /* Aside Mobile */
  asideMobileStateToggle(state, payload = null) {
    const htmlClassName = 'has-aside-mobile-expanded'

    let isShow

    if (payload !== null) {
      isShow = payload
    } else {
      isShow = !state.isAsideMobileExpanded
    }

    if (isShow) {
      document.documentElement.classList.add(htmlClassName)
    } else {
      document.documentElement.classList.remove(htmlClassName)
    }

    state.isAsideMobileExpanded = isShow
  },
  toogleNavBarHomePage(state) {
    state.isActiveNavBarHomePage = !state.isActiveNavBarHomePage
  },

  toogleMenuMobile(state) {
    state.isOpenMenuMobile = !state.isOpenMenuMobile
  },
  closeMenuMobile(state) {
    state.isOpenMenuMobile = false
  },
  setMyProjects(state, projects) {
    state.myProjects = projects
  },
}
